import { UseCase } from '@/core/base/use-case';
import { UserRepository } from '../repositories/user.respository';
import { Observable } from 'rxjs';
import { UserResponse } from '../models/user-response.model';

export class GetUserUseCase implements UseCase<never, UserResponse> {
    constructor(private readonly repository: UserRepository) {}

    execute(): Observable<UserResponse> {
        return this.repository.getUser();
    }
}
